/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import Select from 'react-select';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of products
 */
class SelectorCountry extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            options: [], // The options to fill the selection
            value: props.value,
            hasState: false,
            disabled: props.disabled
        };
    }

    componentWillReceiveProps(props){
        this.setState({
            disabled: props.disabled,
            value: props.value
        });
    }

    /**
     * Call the data API
     */
    callData(){
        // This is promise
        let apiCall = ApiCalls.getCountries();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then(function(data){
            let dataReturned = data.ResponseIsoModelList;
            // Now fill the selections
            for (let i = 0; i < dataReturned.length; i++) {
                arrOptions.push({value: dataReturned[i].IsoCode2, label: dataReturned[i].CountryName});
            }
        }).then(() =>{
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        this.callData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (object) => {
        this.setState({value: object.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
                <div>
                    {
                this.state.options.length > 1 ?
                <Select
                    value={this.state.options.find(option => option.value === this.state.value)}
                    isDisabled={this.state.disabled} options={this.state.options} name="countries"
                    onChange={this.handleChange} placeholder=
                        {
                            <Translate id="register.select-country" options={{renderInnerHtml: false}}/>
                        }
                /> : null}
                </div>
        )
    }
}

export default SelectorCountry;